/* AURÉ 2.0 theme script. Everything here is enhancement: pages work without it. */
(function () {
  'use strict';
  var A = window.AURE || { routes: {}, cartType: 'drawer' };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[aure]', e); } }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#CartDrawer');
  function openDrawer() { if (!drawer) return; drawer.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; var c = $('.drawer__close', drawer); if (c) c.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }
  function refreshDrawer() {
    return fetch((A.routes.root || '/') + '?sections=cart-drawer-body', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-body'];
        if (!html || !drawer) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = $('[data-drawer-inner]', tmp), cur = $('[data-drawer-inner]', drawer);
        if (fresh && cur) cur.replaceWith(fresh);
        var n = fresh ? parseInt(fresh.getAttribute('data-count') || '0', 10) : 0; setCount(n);
      });
  }
  function change(line, qty) {
    return fetch(A.routes.cart_change + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { if (!r.ok) { return r.json().then(function (j) { return refreshDrawer().then(function () { var b = $('.drawer__body', drawer); if (b) { var p = document.createElement('p'); p.className = 'small caution'; p.textContent = j.description || j.message || 'That quantity is not available.'; b.insertBefore(p, b.firstChild); } }); }); } return refreshDrawer(); });
  }
  safe(function () {
    if (!drawer) return;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-open-cart]') && A.cartType === 'drawer') { e.preventDefault(); openDrawer(); return; }
      if (t.closest('[data-close-cart]')) { e.preventDefault(); closeDrawer(); return; }
      var q = t.closest('[data-line-qty]');
      if (q && drawer.contains(q)) { e.preventDefault(); var l = parseInt(q.getAttribute('data-line'), 10), v = parseInt(q.getAttribute('data-line-qty'), 10); change(l, Math.max(0, v)); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('on')) closeDrawer(); });
  });

  /* ---------- Add to cart (AJAX, falls back to normal POST) ---------- */
  safe(function () {
    $$('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (A.cartType !== 'drawer' || !window.fetch || !window.FormData) return;
        e.preventDefault();
        var btns = $$('[type="submit"]', form).concat($$('[form="' + form.id + '"][type="submit"]'));
        btns.forEach(function (b) { b.disabled = true; });
        fetch(A.routes.cart_add + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var er = new Error(j.description || j.message || 'Could not add to bag.'); er.shown = true; throw er; } return j; }); })
          .then(function () { return refreshDrawer(); })
          .then(function () { openDrawer(); })
          .catch(function (err) { var box = $('[data-form-error]', form.parentNode) || $('[data-form-error]'); if (err && err.shown && box) { box.textContent = err.message; box.hidden = false; } else { form.submit(); } })
          .then(function () { btns.forEach(function (b) { b.disabled = false; }); });
      });
    });
  });

  /* ---------- Purchase options (subscribe vs one time) ---------- */
  safe(function () {
    $$('[data-po]').forEach(function (po) {
      var form = document.getElementById(po.getAttribute('data-form'));
      var hidden = form ? $('input[name="selling_plan"]', form) : null;
      var sel = $('select[data-plan-select]', po);
      function sync() {
        var chosen = $('input[name="purchase_type"]:checked', po);
        var sub = chosen && chosen.value === 'subscribe';
        if (hidden) { hidden.value = sub && sel ? sel.value : ''; hidden.disabled = !sub; }
        $$('[data-show-sub]').forEach(function (el) { el.hidden = !sub; });
        $$('[data-show-once]').forEach(function (el) { el.hidden = sub; });
        var price = sub && sel ? sel.options[sel.selectedIndex].getAttribute('data-price') : po.getAttribute('data-once-price');
        if (price) $$('[data-live-price]').forEach(function (el) { el.textContent = price; });
        if (sub && sel) { var note = sel.options[sel.selectedIndex].getAttribute('data-renew'); $$('[data-renew-text]').forEach(function (el) { el.textContent = note || ''; }); }
      }
      $$('input[name="purchase_type"]', po).forEach(function (r) { r.addEventListener('change', sync); });
      if (sel) sel.addEventListener('change', sync);
      sync();
    });
  });

  /* ---------- Quantity steppers on PDP ---------- */
  safe(function () {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () { var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-step'), 10); input.value = Math.max(1, Math.min(10, v)); });
      });
    });
  });

  /* ---------- Sticky add to cart (mobile) ---------- */
  safe(function () {
    var bar = $('[data-sticky-atc]'), anchor = $('[data-buy-anchor]'), footer = $('.ftr');
    if (!bar || !anchor) return;
    function apply() {
      var past = anchor.getBoundingClientRect().bottom < 0;
      var nearEnd = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var on = past && !nearEnd;
      bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply);
    apply();
  });

  /* ---------- Gallery: dots (mobile) and thumbnails (desktop) ---------- */
  safe(function () {
    var gal = $('[data-gallery]');
    if (!gal) return;
    var dots = $$('[data-gallery-dots] span'), thumbs = $$('[data-gallery-thumbs] button');
    function idx() { var w = gal.firstElementChild ? gal.firstElementChild.getBoundingClientRect().width : 1; return Math.round(gal.scrollLeft / (w + 8)); }
    function mark() { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('on', k === i); }); thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); }); }
    gal.addEventListener('scroll', mark, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-index'), 10), item = gal.children[i];
        if (item) { gal.scrollTo({ left: item.offsetLeft - gal.firstElementChild.offsetLeft, behavior: 'smooth' }); }
        thumbs.forEach(function (x) { x.classList.toggle('on', x === t); });
      });
    });
  });

  /* ---------- Ritual quiz ---------- */
  safe(function () {
    $$('[data-quiz]').forEach(function (quiz) {
      var form = $('form', quiz), out = $('[data-quiz-result]', quiz);
      if (!form || !out) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var score = { halo: 0, clear: 0, ease: 0, dusk: 0, ritual: 0 };
        $$('input:checked', form).forEach(function (i) { (i.getAttribute('data-score') || '').split(' ').forEach(function (k) { if (k && score.hasOwnProperty(k)) score[k] += 1; }); });
        var best = 'ritual', top = -1;
        ['ritual', 'halo', 'clear', 'ease', 'dusk'].forEach(function (k) { if (score[k] > top) { top = score[k]; best = k; } });
        var answered = $$('input:checked', form).length;
        var need = parseInt(form.getAttribute('data-questions') || '4', 10);
        if (answered < need) { var m = $('[data-quiz-msg]', quiz); if (m) { m.hidden = false; } return; }
        var m2 = $('[data-quiz-msg]', quiz); if (m2) m2.hidden = true;
        $$('[data-result]', out).forEach(function (r) { r.hidden = r.getAttribute('data-result') !== best; });
        out.hidden = false;
        out.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  });

  /* ---------- Gentle reveals: visible by default; only below-fold blocks in a visible tab get hidden ---------- */
  safe(function () {
    if (document.visibilityState !== 'visible') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = $$('[data-rv]').filter(function (el) { return el.getBoundingClientRect().top > window.innerHeight * 1.05; });
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add('rv-hide'); });
    function check() {
      var h = window.innerHeight;
      els = els.filter(function (el) {
        if (el.getBoundingClientRect().top < h * 0.92) { el.classList.add('rv-show'); el.classList.remove('rv-hide'); return false; }
        return true;
      });
      if (!els.length) window.removeEventListener('scroll', check);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState !== 'visible') { els.forEach(function (el) { el.classList.remove('rv-hide'); }); els = []; } });
    setTimeout(function () { els.forEach(function (el) { el.classList.remove('rv-hide'); }); }, 6000);
  });
})();
